import { h, Component } from 'preact';
import { route } from 'preact-router';
import { translate } from 'react-i18next';

import Button from './Button.js';


class TwoFactorStatus extends Component {
	state = {
		twoFactorData: null
	}

  enableTwoFactor = () => {
  	route('/two-factor', true);
	}

	disableTwoFactor = () => {
		route('/two-factor-disable', true);
	}

	fetchTwoFactorInfo = (webToken) => {
		fetch('https://api.hirezstudios.com/acct/twoFactorInfo', {
  		method: 'post',
  		headers: {
  			'Content-Type': 'application/json'
  		},
  		body: `{"webToken": "${webToken}"}`
    	}).then((response) => response.json()).then((response) => {
  			this.setState({ twoFactorData: response });
    	});
	}

	shouldComponentUpdate(nextProps) {
		if (this.state.twoFactorData === null && nextProps.userData.webToken !== null) {
			this.fetchTwoFactorInfo(nextProps.userData.webToken);
		}
	}
	
	componentDidMount() {
		this.fetchTwoFactorInfo(this.props.userData.webToken);
	}

  render() {
		const { t } = this.props;
  	return (
  		<div className="c-TwoFactorStatus">
  			<h4>{t('Two - Factor Sign In')}</h4>
				<p>{t('Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.')} <a href="#learn-more">{t('Learn More.')}</a></p>
				{this.state.twoFactorData &&
					<table className="current-settings">
						<tr><td>{t('Status:')}</td><td className={this.state.twoFactorData.validationPeriod === 'NONE' ? 'is-red' : 'is-green'}>{this.state.twoFactorData.validationPeriod === 'NONE' ? t('INACTIVE') : t('ACTIVE')}</td></tr>
						{this.state.twoFactorData.validationPeriod !== 'NONE' &&
							<tbody>
								{this.state.twoFactorData.phone !== null &&
								<tr><td>{t('Phone Number:')}</td><td>{this.state.twoFactorData.phone}</td></tr>
								}
								{this.state.twoFactorData.backupEmail !== null &&
									<tr><td>{t('Recovery E-Mail:')}</td><td>{this.state.twoFactorData.backupEmail}</td></tr>	
								}
								{this.state.twoFactorData.validationPeriod !== null &&
									<tr><td>{t('Frequency:')}</td><td>{this.state.twoFactorData.validationPeriod}</td></tr>
								}
								{this.state.twoFactorData.validationOption !== null &&
									<tr><td>{t('Method:')}</td><td>{this.state.twoFactorData.validationOption}</td></tr>
								}
							</tbody>
						}
					</table>
				}
  			<p>{t('Want to change your two factor settings? Click below.')}</p>
  			{this.state.twoFactorData && this.state.twoFactorData.validationPeriod === 'NONE' &&
					<div className="buttons-wrapper">
						<Button
							color="blue"
							copy={t('Enable')}
							onClick={this.enableTwoFactor}
						/>
					</div>
				}
				{this.state.twoFactorData && this.state.twoFactorData.validationPeriod !== 'NONE' &&
					<div className="buttons-wrapper">
						<Button
							color="blue"
							copy={t('Edit')}
							onClick={this.enableTwoFactor}
						/>
						<Button
							copy={t('Disable')}
							onClick={this.disableTwoFactor}
						/>
					</div>
				}
  		</div>
  	);
  }
}

export default translate(['common'], { withRef: true })(TwoFactorStatus);


// WEBPACK FOOTER //
// ./components/TwoFactorStatus.js